import React, { useMemo } from 'react';

import { Tooltip, Button } from '@bringg/react-components';
import { PrivilegeTypes } from '@bringg/types';
import { observer } from 'mobx-react-lite';

import { NO_ROUTE_ID } from '../../../../../../stores/routes-planner-store';
import { useHasAccess } from '../../../../../..//hooks/use-has-access';
import useStore from '../../../../../../stores/helpers/use-context';
import { RoutesPlannerRun } from '../../../../../../types';
import { UpdateVehicleOnRunProps } from './../../../../../../types/routes-planner-app';

import './vehicle-cell.scss';

export type vehicleType = 'vehicle' | 'trailer';

interface Props {
	vehicleType: vehicleType;
	run: RoutesPlannerRun;
	canUpdateVehicle: boolean;
	type?: string;
	unassignTranslation: string;
	openVehicleAssignerModal?: (
		runId: number,
		onClose: ({ runId, vehicleId, tasksIds }: UpdateVehicleOnRunProps) => void
	) => void;
}

const VehicleCell = ({
	canUpdateVehicle,
	type,
	unassignTranslation,
	run,
	vehicleType,
	openVehicleAssignerModal
}: Props) => {
	const stopPropagation = e => {
		e.stopPropagation();
	};

	const { runToTasksInPresentedDate, updateVehicleOnRun } = useStore();
	const allowAssignDriverToTask = useHasAccess(PrivilegeTypes.ALLOW_ASSIGN_VEHICLE_TO_RUN);
	const className = type ? type : 'vehicle-name';

	const { vehiclesById } = useStore();

	const vehicleName = useMemo(() => {
		if (!run) {
			return '';
		}
		if (vehicleType === 'vehicle') {
			return vehiclesById[run.vehicle_id]?.name || unassignTranslation;
		}

		const taskWithTrailer = runToTasksInPresentedDate[run.id].find(({ vehicle_id }) => {
			if (!vehicle_id) return false;
			if (run.vehicle_id && run.vehicle_id === vehicle_id) return false;
			return true;
		});

		return vehiclesById[taskWithTrailer?.vehicle_id]?.name || unassignTranslation;
	}, [vehiclesById, runToTasksInPresentedDate, run?.vehicle_id]);

	const onVehicleNameClick = (runId: number) => {
		openVehicleAssignerModal(runId, updateVehicleOnRun);
	};

	return (
		<div className={`route-row-item vehicle-cell ${className}`}>
			{run && vehicleName && allowAssignDriverToTask ? (
				<Tooltip
					key="route-row-driver-name"
					title={run.id !== NO_ROUTE_ID ? vehicleName : ''}
					placement="top"
					overlayClassName="route-row-vehicle-name"
				>
					{canUpdateVehicle ? (
						<Button
							type="link"
							data-test-id={`route-row-${className}-link`}
							className={`route-link route-row-${className}-link`}
							onClick={e => {
								stopPropagation(e);
								onVehicleNameClick(run.id);
							}}
						>
							<span>{vehicleName}</span>
						</Button>
					) : (
						<span className={`route-no-link route-row-${className}-without-link`}>{vehicleName}</span>
					)}
				</Tooltip>
			) : (
				<div>-</div>
			)}
		</div>
	);
};

export default observer(VehicleCell);
